var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteOutlinedSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 3.33333H13.166V1.66667C13.166 1.22464 12.9904 0.800716 12.6779 0.488155C12.3653 0.175595 11.9414 0 11.4993 0L6.49935 0C6.05732 0 5.6334 0.175595 5.32084 0.488155C5.00828 0.800716 4.83268 1.22464 4.83268 1.66667V3.33333H0.666016V5H2.33268V17.5C2.33268 18.163 2.59607 18.7989 3.06492 19.2678C3.53376 19.7366 4.16964 20 4.83268 20H13.166C13.8291 20 14.4649 19.7366 14.9338 19.2678C15.4026 18.7989 15.666 18.163 15.666 17.5V5H17.3327V3.33333ZM6.49935 1.66667H11.4993V3.33333H6.49935V1.66667ZM13.9993 17.5C13.9993 17.721 13.9116 17.933 13.7553 18.0893C13.599 18.2455 13.387 18.3333 13.166 18.3333H4.83268C4.61167 18.3333 4.39971 18.2455 4.24343 18.0893C4.08715 17.933 3.99935 17.721 3.99935 17.5V5H13.9993V17.5Z",
    fill: "#DA1E27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 8.33301H6.5V14.9997H8.16666V8.33301Z",
    fill: "#DA1E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4987 8.33301H9.83203V14.9997H11.4987V8.33301Z",
    fill: "#DA1E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlinedSmall);
export default __webpack_public_path__ + "static/media/deleteOutlinedSmall.bdef9c6dbe3bddb2acd5a11aaeae86e1.svg";
export { ForwardRef as ReactComponent };